<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="loader" v-if="pageEngagementDetails.length == 0"></div>
    <div class="vx-row" ref="counts">
      <!-- CARD 1: CONGRATS -->
      <div
        class="vx-col w-full lg:w-1/2 lg:mt-0 mt-base mouse-pointer"
        v-on:click="sendTo('/analytics/page-view')"
        v-if="pageEngagementDetails.length > 0 && roundTableDetails.length > 0"
      >
        <vx-card>
          <div slot="no-body">
            <statistics-card-line
              icon="UsersIcon"
              :statistic="totalPageEngagementCount"
              statisticTitle="Engagement in last 7 days"
              :chartData="pageEngagementDetails"
              type="area"
            ></statistics-card-line>
          </div>
        </vx-card>
      </div>
      <div
        class="vx-col w-full lg:w-1/2 lg:mt-0 mb-8 mt-base mouse-pointer"
        v-on:click="sendTo('/analytics/page-view')"
        v-else-if="
          pageEngagementDetails.length > 0 && roundTableDetails.length == 0
        "
      >
        <vx-card>
          <div slot="no-body">
            <statistics-card-line
              icon="UsersIcon"
              :statistic="totalPageEngagementCount"
              statisticTitle="Engagement in last 7 days"
              :chartData="pageEngagementDetails"
              type="area"
            ></statistics-card-line>
          </div>
        </vx-card>
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base mouse-pointer"
        v-on:click="sendTo('/event/sessions')"
        v-if="totalSessionCount != null"
        style="display: flex"
      >
        <vx-card :title="'Sessions: ' + totalSessionCount">
          <div slot="no-body" v-if="totalSessionCount > 0">
            <vue-apex-charts
              class="mb-10"
              type="donut"
              height="150"
              :options="sessionDetailsOptions"
              :series="sessionDetails"
            />
          </div>
          <div
            slot="no-body"
            style="text-align: center; margin-top: 30%"
            v-else
          >
            <span>No Sessions are available</span>
          </div>
        </vx-card>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base mouse-pointer"
        v-on:click="sendTo('/event/roundtables')"
        v-if="totalRoundTableCount != null"
        style="display: flex"
      >
        <vx-card :title="totalRoundTableCount > 0 && totalRoundTableCount > 30 ? 'Round Tables' : 'Round Tables: ' + totalRoundTableCount">
          <div slot="no-body" v-if="totalRoundTableCount > 0">
            <div class="roundtable-count-hld" v-if="totalRoundTableCount > 30">
              <h3>{{totalRoundTableCount}}</h3>
            </div>
            <vue-apex-charts v-else
              type="pie"
              height="200"
              class="mb-10"
              :options="roundtableOptions"
              :series="roundTableDetails"
            />
          </div>
          <div
            slot="no-body"
            style="text-align: center; margin-top: 30%"
            v-else
          >
            <span>No Round Tables are available</span>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row" ref="users">
      <!-- CARD 4: SESSION -->
      <div
        class="vx-col w-full md:w-1/2 mb-base adjust-card"
        v-if="totalRegistrations > 0"
      >
        <vx-card title="Registrations">
          <div
            class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row"
          >
            <!-- LEFT COL -->
            <div
              class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between"
            >
              <div>
                <h2 class="mb-1 font-bold">
                  {{ totalRegistrations | k_formatter }}
                </h2>
                <span class="font-medium">Registrations</span>
              </div>
              <div class="vx-row">
                <div class="vx-col w-1/2 mb-3">
                  <p v-if="totalFreeRegistrations > 0">
                    <b>Free</b>: {{ totalFreeRegistrations }}
                  </p>
                </div>
                <div class="vx-col w-1/2 mb-3">
                  <p v-if="totalPaidRegistrations > 0">
                    <b>Paid</b>: {{ totalPaidRegistrations }}
                  </p>
                </div>
                <div class="vx-col w-1/2 mb-3">
                  <p v-if="totalUnPaidRegistrations > 0">
                    <b>Un-Paid</b>: {{ totalUnPaidRegistrations }}
                  </p>
                </div>
                <div class="vx-col w-1/2 mb-3">
                  <p></p>
                </div>
              </div>
              <vs-button
                icon-pack="feather"
                icon="icon-chevrons-right"
                icon-after
                class="shadow-md w-full lg:mt-0 mt-4 mouse-pointer"
                @click="sendToAttendee"
                >View Details</vs-button
              >
            </div>

            <!-- RIGHT COL -->
            <div
              class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base"
            >
              <!-- <change-time-duration-dropdown class="self-end" /> -->
              <vs-dropdown vs-trigger-click class="cursor-pointer self-end">
                <small
                  class="flex cursor-pointer"
                  @click="changeRegCountDuration('7')"
                >
                  <span>Last 7 days</span>
                  <feather-icon
                    icon="ChevronDownIcon"
                    svgClasses="h-4 w-4"
                    class="ml-1"
                  />
                </small>
              </vs-dropdown>
              <vue-apex-charts
                type="bar"
                height="200"
                :options="analyticsData.salesBar.chartOptions"
                :series="registrationDetails"
              />
            </div>
          </div>
          <vs-divider class="my-6"></vs-divider>
          <vs-tabs>
            <vs-tab
              label="By Country"
              icon-pack="feather"
              icon="icon-map"
              v-if="countryFlg == true"
            >
              <chartjs-component-bar-chart
                :height="150"
                :data="regCountryData"
                :options="regCountryoptions"
              ></chartjs-component-bar-chart>
            </vs-tab>
            <vs-tab
              label="By Device type"
              icon-pack="feather"
              icon="icon-cpu"
              v-if="deviceInfoFlg == true"
            >
              <chartjs-component-bar-chart
                :height="150"
                :data="regDeviceInfoData"
                :options="regDeviceInfoOptions"
              ></chartjs-component-bar-chart>
            </vs-tab>
            <vs-tab
              label="By Registration type"
              icon-pack="feather"
              icon="icon-airplay"
              v-if="regtypeFlg == true"
            >
              <chartjs-component-bar-chart
                :height="150"
                :data="regTypeData"
                :options="regTypeOptions"
              ></chartjs-component-bar-chart>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
      <div
        class="vx-col w-full md:w-1/2 mb-base adjust-card"
        v-else-if="totalRegistrations == 0"
      >
        <vx-card title="Registrations">
          <div
            class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row"
          >
            <div
              class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between"
            >
              <div class="vx-row">
                <div slot="no-body" style="text-align: center; margin-top: 30%">
                  <span
                    >No Registrations In Last 7 days, click View Details to see
                    more</span
                  >
                </div>
              </div>
              <vs-button
                icon-pack="feather"
                icon="icon-chevrons-right"
                icon-after
                class="shadow-md w-full lg:mt-0 mt-4 mouse-pointer"
                @click="sendToAttendee"
                >View Details</vs-button
              >
            </div>

            <!-- RIGHT COL -->
            <div
              class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base"
            ></div>
          </div>
          <vs-divider class="my-6"></vs-divider>
        </vx-card>
      </div>

      <div
        class="vx-col w-full lg:w-1/2 mb-base"
        v-if="allEntityData.length > 0"
      >
        <vx-card title="Overview">
          <!-- CARD ACTION -->
          <!-- Chart -->
          <div slot="no-body">
            <vue-apex-charts
              type="radialBar"
              height="420"
              :options="entityOptions"
              :series="entityCounts"
            />
          </div>
          <ul>
            <li
              v-for="orderData in allEntityData"
              :key="orderData.orderType"
              class="flex mb-1 justify-between"
            >
              <span class="flex items-center">
                <span
                  class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid"
                  :class="`border-${orderData.color}`"
                ></span>
                <span class="font-semibold">{{ orderData.orderType }}</span>
              </span>
              <span>{{ orderData.counts }}</span>
            </li>
          </ul>
          <div slot="no-body">
            <div class="flex flex-row justify-between px-8 pb-4 mt-4">
              <p class="text-center">
                <span class="block">Total Registered</span>
                <span class="text-2xl font-semibold">{{
                  turnOut.totalAttendees
                }}</span>
              </p>
              <p class="text-center">
                <span class="block">Logged-In</span>
                <span class="text-2xl font-semibold">{{
                  turnOut.totalLoginToday
                }}</span>
              </p>
              <p class="text-center">
                <span class="block">Turn-out %</span>
                <span class="text-2xl font-semibold"
                  >{{ turnOut.totalPercentage }} %</span
                >
              </p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" v-if="pageViewDetails.length > 0">
      <div class="vx-col w-full mb-base">
        <vx-card title="Engagement- All days">
          <vs-tabs>
            <vs-tab label="Event" icon-pack="feather" icon="icon-map">
              <vs-button
                style="float: right"
                icon-pack="feather"
                icon="icon-chevrons-right"
                icon-after
                class="shadow-md lg:mt-0 mouse-pointer"
                @click="sendToPageEngagement"
                >View Details</vs-button
              >
              <div class="flex">
                <span class="flex items-center"
                  ><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div>
                  <span>Views</span></span
                >
                <span class="flex items-center ml-4"
                  ><div class="h-3 w-3 rounded-full mr-1 bg-danger"></div>
                  <span>Click</span></span
                >
              </div>
              <vue-apex-charts
                type="bar"
                height="277"
                :options="pageViewOptions"
                :series="pageViewDetails"
              />
            </vs-tab>
            <!-- <vs-tab
              label="Exhibitor"
              icon-pack="feather"
              icon="icon-cpu"
              v-if="exhibitorTabFlag == true"
            >
              <vs-button
                @click="sendToBusinessCardReport"
                style="float: right"
                class="shadow-md lg:mt-0 mouse-pointer mr-10"
                color="primary"
                type="border"
                >Business Card Exchanges
              </vs-button>
              <vs-button
                style="float: right"
                icon-pack="feather"
                icon="icon-chevrons-right"
                color="primary"
                type="border"
                icon-after
                class="shadow-md lg:mt-0 mouse-pointer mr-2"
                @click="sendToExhibitor"
                >Click Details</vs-button
              >
              <div class="flex">
                <span class="flex items-center"
                  ><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div>
                  <span>Click</span></span
                >
                <span class="flex items-center ml-4"
                  ><div
                    class="h-3 w-3 rounded-full mr-1"
                    style="color: #008080; background: #008080"
                  ></div>
                  <span>Business Card Exchange</span></span
                >
              </div>
              <vue-apex-charts
                type="bar"
                height="277"
                :options="exhibitorPageViewOptions"
                :series="exhibitorPageViewDetails"
              />
            </vs-tab> -->

            <vs-tab
              v-if="meetingCount > 0"
              label="Meeting"
              icon-pack="feather"
              icon="icon-bar-chart"
            >
          <!-- ==  {{meetingOptions}} -->
              <!-- <vs-button
                style="float: right"
                icon-pack="feather"
                icon="icon-chevrons-right"
                icon-after
                class="shadow-md lg:mt-0 mouse-pointer"
                @click="sendToMeeting"
                >View Details</vs-button
              > -->
              <vue-apex-charts
                type="bar"
                height="350"
                :options="meetingOptions"
                :series="meetingData"
              ></vue-apex-charts>

            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>

    <div class="vx-row" ref="logins">
      <div
        class="vx-col w-full mb-base"
        v-if="normalLogin > 0 || googleLogin > 0"
      >
        <vx-card title="Login Summary- All days">
          <vs-button
            icon-pack="feather"
            icon="icon-chevrons-right"
            icon-after
            class="shadow-md lg:mt-0 mouse-pointer"
            @click="sendToLogin"
            >View Details</vs-button
          >
          <div slot="no-body" class="p-6 pb-0">
            <div class="flex">
              <div class="mr-6">
                <p class="mb-1 font-semibold">
                  Normal <input type="color" value="#F97794" disabled />
                </p>
                <p class="text-3xl text-success" style="text-align: center">
                  <sup class="text-base mr-1"></sup>{{ normalLogin }}
                </p>
              </div>
              <div>
                <p class="mb-1 font-semibold">
                  Google <input type="color" value="#b8c2cc" disabled />
                </p>
                <p class="text-3xl" style="text-align: center">
                  <sup class="text-base mr-1"></sup>{{ googleLogin }}
                </p>
              </div>
            </div>
            <vue-apex-charts
              type="line"
              height="266"
              :options="loginGraphOptions"
              :series="loginTypeData"
            />
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import analyticsData from "../ui-elements/card/analyticsData.js";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChartjsComponentBarChart from "../charts-and-maps/charts/chartjs/charts-components/ChartjsComponentBarChart.vue";
// Store Module
import moduleDashboardManagement from "@/store/dashboard/moduleDashboard.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import ls from "@/common/localStorage";

export default {
  data() {
    return {
      registrationDetails: [],
      roundTableDetails: [],
      sessionDetails: [],
      sessionDetailsOptions: [],
      pageEngagementDetails: [],
      totalRegistrations: null,
      totalRoundTableCount: null,
      totalSessionCount: null,
      totalPageEngagementCount: null,
      totalFreeRegistrations: null,
      totalPaidRegistrations: null,
      totalUnPaidRegistrations: null,
      allTotalRegistrations: null,
      allEntityData: {},
      loginTypeData: [],
      normalLogin: 0,
      googleLogin: 0,
      entityCounts: [],
      entityOptions: {},
      analyticsData,
      pageViewOptions: {},
      pageViewDetails: [],
      roundtableOptions: {},
      regCountryData: {},
      regCountryoptions: {},
      countryFlg: null,
      loginGraphOptions: {},
      regDeviceInfoData: {},
      regDeviceInfoOptions: {},
      deviceInfoFlg: null,
      regTypeData: {},
      regTypeOptions: {},
      regtypeFlg: null,
      exhibitorPageViewOptions: {},
      exhibitorPageViewDetails: [],
      exhibitorTabFlag: false,
      turnOut: {},
      meetingCount: 0,
      meetingData: {},
      meetingOptions: {},
    };
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChartjsComponentBarChart,
  },
  methods: {
    fetchRegistraionCount() {
      this.$store
        .dispatch("dashboardManagement/fetchRegistrationCountDetails")
        .then((res) => {
          this.registrationDetails = res.data;
          this.totalRegistrations = res.data[0].TotalRegistrations;
          this.totalFreeRegistrations = res.data[0].freecount;
          this.totalPaidRegistrations = res.data[0].paidcount;
          this.totalUnPaidRegistrations = res.data[0].unpaidcount;
          this.allTotalRegistrations =
            res.data[0].freecount +
            res.data[0].paidcount +
            res.data[0].unpaidcount;
          this.regTypeData = res.data[0].data;
          this.regTypeOptions = res.data[0].options;
          this.regtypeFlg = res.data[0].regtypeFlg;

          this.regCountryData = res.data1[0].data;
          this.regCountryoptions = res.data1[0].options;
          this.countryFlg = res.data1[0].countryFlg;
          this.regDeviceInfoData = res.data2[0].data;
          this.regDeviceInfoOptions = res.data2[0].options;
          this.deviceInfoFlg = res.data2[0].deviceFlg;
          
        })
        .catch((err) => {
          console.error(err);
        });
    },
    sendToAttendee() {
      this.$router.push("/event/attendees/");
    },
    sendTo(data) {
      this.$router.push(data);
    },
    fetchRoundtableCount() {
      this.$store
        .dispatch("dashboardManagement/fetchRoundTablesCount")
        .then((res) => {
          this.roundTableDetails = res.data[0].data;
          this.roundtableOptions = res.data[0].options;
          this.totalRoundTableCount = res.data[0].count;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    fetchSessionCount() {
      this.$store
        .dispatch("dashboardManagement/fetchSessionCount")
        .then((res) => {
          this.totalSessionCount = res.data[0].count;
          this.sessionDetails = res.data[0].data;
          this.sessionDetailsOptions = res.data[0].options;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    fetchAllEntityCount() {
      this.$store
        .dispatch("dashboardManagement/fetchAllEntityCount")
        .then((res) => {
          this.allEntityData = res.data;
          this.entityCounts = res.data1;
          this.entityOptions = res.options;
          this.turnOut = res.turnout;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    fetchLast7DaysEngagementCount() {
      this.$store
        .dispatch("dashboardManagement/fetchLast7DaysEngagementCount")
        .then((res) => {
          this.pageEngagementDetails = res.data;
          this.totalPageEngagementCount = res.data[0].count;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    fetchPageEngagementUrl() {
      this.$store
        .dispatch("dashboardManagement/fetchEngagementUrlDetails")
        .then((res) => {
          this.pageViewOptions = res.data[0].options;
          this.pageViewDetails = res.data1;
          this.exhibitorPageViewOptions = res.data3[0].options;
          this.exhibitorPageViewDetails = res.data2;
          if (res.data2[0].data.length > 0) {
            this.exhibitorTabFlag = true;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onScroll() {
      var usersHeading = this.$refs["users"];
      var countHeading = this.$refs["counts"];
      var loginHeading = this.$refs["logins"];
      if (usersHeading) {
        var marginTopUsers = usersHeading.getBoundingClientRect().top;
        var innerHeight = window.innerHeight;

        if (marginTopUsers - innerHeight < -50) {
          this.fetchRegistraionCount();
        }
      }
      if (countHeading) {
        var marginTopUsers = countHeading.getBoundingClientRect().top;
        var innerHeight = window.innerHeight;

        if (marginTopUsers - innerHeight < -50) {
          //this.fetchLiveAttendeeCount();
          this.fetchRoundtableCount();
          this.fetchSessionCount();
        }
      }
      if (loginHeading) {
        var marginTopUsers = loginHeading.getBoundingClientRect().top;
        var innerHeight = window.innerHeight;

        if (marginTopUsers - innerHeight < -50) {
          this.fetchLoginCount();
        }
      }
    },
    changeRegCountDuration(data) {
      alert("no of days===", data);
    },

    fetchLoginCount() {
      this.$store
        .dispatch("dashboardManagement/fetchLoginTypCount")
        .then((res) => {
          this.loginTypeData = res.data;
          this.normalLogin = res.data[0].sum;
          this.googleLogin = res.data[1].sum;
          this.loginGraphOptions = res.options;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    sendToLogin() {
      this.$router.push("/analytics/user-login");
    },
    sendToPageEngagement() {
      this.$router.push("/analytics/page-view");
    },
    sendToExhibitor() {
      this.$router.push("/event/exhibitors");
    },
    sendToBusinessCardReport() {
      this.$router.push("/report/businessCard");
    },
    fetchBrandingJson() {
      this.$store
        .dispatch("eventManagement/fetchBrandingJson")
        .then((res) => {
          if (res) {
            let info = {
              Session_Event_Theme: res.appColorHexCodeType,
            };
            ls.setSessionUserInfo(info);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchMeetingCount() {
      this.$store
        .dispatch("dashboardManagement/fetchMeetingCount")
        .then((res) => {
          console.log("res===",res);
          this.meetingCount = res.data[0].count;
          this.meetingData = res.data[0].data;
          this.meetingOptions = res.data[0].options;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    sendToMeeting() {
      this.$router.push("/event/meetings");
    },
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("scroll", this.onScroll);
      this.onScroll(); // needed for initial loading on page
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  created() {
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    if (!moduleDashboardManagement.isRegistered) {
      this.$store.registerModule(
        "dashboardManagement",
        moduleDashboardManagement
      );
      moduleDashboardManagement.isRegistered = true;
    }
    this.fetchMeetingCount();
    this.fetchLast7DaysEngagementCount();
    this.fetchBrandingJson();
    this.fetchPageEngagementUrl();
    this.fetchAllEntityCount();
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
.roundtable-count-hld{
    height: 120px;
    width: 120px;
    margin: 25px auto 0;
    border: 6px solid #55ea86;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.roundtable-count-hld h3 {
    margin: 0;
    font-size: 25px;
    color: #333;
}
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
  .mouse-pointer {
    cursor: pointer;
  }
  .two-col-special {
    padding: 5;
  }

  .two-col-special li {
    display: inline-block;
    width: 50%;
    padding: 0;
    vertical-align: top;
  }
  span.padd {
    padding-left: 10%;
  }
  .adjust-card {
    display: flex;
  }
  .loader {
    position: absolute;
    left: calc(50% - 35px);
    top: 250%;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 3px solid transparent;
    border-left: 3px solid rgba(121, 97, 249, 1);
    -webkit-animation: rotateOpacity 1s ease infinite 0.2s;
    animation: rotateOpacity 1s ease infinite 0.2s;
  }
  @keyframes rotateOpacity {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
      opacity: 0.1;
    }
    100% {
      -webkit-transform: rotate(1turn);
      transform: rotate(1turn);
      opacity: 1;
    }
  }
}
</style>
